export enum BillingTarget {
  AGENCY_PAY_RATE = 'AGENCY_PAY_RATE',
  CLIENT_BILL_RATE = 'CLIENT_BILL_RATE',
}
